import { render, staticRenderFns } from "./LanguagesTable.vue?vue&type=template&id=264779ec&"
import script from "./LanguagesTable.vue?vue&type=script&lang=ts&"
export * from "./LanguagesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports